<template>
  <section id="company_container" class="custom-container">
    <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
    <div class="columns v-align-center">

      <div class="columns">
        <div class="column">
          <b-field label="Digitar identificación">
            <div class="control-content" style="margin: auto">
              <vs-input
                  type="text"
                  v-model="identification"
                  placeholder="Identificación"
              >
              </vs-input>
            </div>
            <vs-button
                style="margin: 10px"
                color="primary"
                class="pl-5 pr-5 control-btn"
                type="filled"
                icon="search"
                title="Cédula"
                @click="findByIdentification">Buscar

            </vs-button>
          </b-field>
        </div>
      </div>
      <div class="column text-right">
        <vs-button
            color="primary"
            icon="add"
            class="btn-add-device"
            @click="addEntity"
        >Crear tercero
        </vs-button
        >
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <b-table :data="tableData" max-items="6">
          <b-table-column field="code" label="Id" v-slot="props">
            <text-highlight :queries="search">
              {{ props.row.code }}
            </text-highlight>
          </b-table-column>
          <b-table-column
              field="company.code"
              label="Identificación"
              v-slot="props"
          >
            <text-highlight :queries="search">
              {{ props.row.identification }}
            </text-highlight>
          </b-table-column>
          <b-table-column
              field="type"
              label="Tipo de identificación"
              v-slot="props"
          >
            <text-highlight :queries="search">
              {{ props.row.identificationType.title }}
            </text-highlight>
          </b-table-column>
          <b-table-column field="title" label="Nombre" v-slot="props">
            <div class="flex name-options-table">
              <span class="label-title">
                <text-highlight :queries="search">
                  {{ props.row.name }}
                </text-highlight>
              </span>
              <div class="options flex">
                <button
                    class="btn primary edit"
                    v-on:click="editRow(props.row.code)"
                    title="Editar"
                >
                  <span class="material-icons"> edit </span>
               Editar </button>
              </div>
            </div>
          </b-table-column>
          <template #empty>
            <div class="has-text-centered">Sin registros</div>
          </template>
        </b-table>
      </div>
    </div>
  </section>
</template>

<script>
import toast from "@/global/ToastConfig";
import entityEndpoint from "@/endpoints/core/EntityEndpoint";

export default {
  components: {},
  data: () => ({
    isLoading: false,
    selected: null,
    tableData: [],
    totalNumData: 0,
    originalData: [],
    search: "",
    page: 1,
    forRemove: null,
    pagination: 10,
    totalPages: 0,
    company: null,
    paginationList: [
      {id: 10, label: "10"},
      {id: 30, label: "30"},
      {id: 60, label: "60"},
      {id: 100, label: "100"},
      {id: 1000, label: "1000"},
    ],
    identification: "",
  }),
  methods: {
    editRow(entityCode) {
      this.$router.push({name: "Crear tercero", params: {entityCode: entityCode}});
    },
    addEntity() {
      this.$router.push("/view/users/entities/create");
    },
    findByIdentification() {
      this.isLoading = true;
      if (this.identification == null || this.identification == "") {
        this.isLoading = false;
        toast.info("Digite por favor la identificación")
        return;
      }
      this.tableData = [];
      entityEndpoint.findByIdentification(this.identification)
          .then(info => {
            this.isLoading = false;
            this.tableData = info;
          });
    },
  },
};
</script>

<style>
.sub-title {
  font-size: 1.6em;
  margin: 0;
  padding: 0;
}

.custom-container {
  margin-top: 20px;
}

.input-search {
  max-width: 300px;
}

.btn-add-device {
  margin-left: auto;
}

.text-right {
  display: flex;
  justify-content: flex-end;
}

.name-options-table {
  display: flex;
  width: 100%;
}

.name-options-table .options {
  margin-left: auto;
}

.name-options-table .options .btn {
  width: 30px;
  height: 30px;
  border-radius: 5px;
  background-color: #efefef;
  display: flex;
  padding: 0;
  outline: none;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  transition: all 1ms ease;
}

.name-options-table .options .btn span {
  font-size: 1.5em;
}

.name-options-table .options .btn:last-child {
  margin-right: 0;
}

.name-options-table .options .btn.primary {
  background-color: #1d76fb;
  color: #ffffff;
}

.name-options-table .options .btn:active {
  background-color: black;
  color: #ffffff;
}

.pagination-select {
  max-width: 120px;
}

.input-search-content {
  display: flex;
}
</style>
